"use client";

import { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { allPosts, categories } from "./posts-data"; // <-- IMPORTANDO DO NOSSO ARQUIVO CENTRAL

const BlogPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("Todas");
  const [searchTerm, setSearchTerm] = useState("");

  const filteredPosts = allPosts.filter(
    (post) =>
      (selectedCategory === "Todas" || post.category === selectedCategory) &&
      post.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div
      className="pt-28 pb-16 px-6 md:px-20 bg-[#F9FAFB] font-montserrat relative"
      style={{ backgroundImage: "url(/estampa-02.webp)", backgroundRepeat: "repeat-y", backgroundPosition: "right", backgroundSize: "contain", opacity: 1 }}
    >
      <div className="absolute inset-0 bg-white/80 z-0" />

      <div className="mb-4 relative z-10">
        <Link href="/" scroll={false}>
          <button className="text-sm text-[#7A3B2E] border border-[#7A3B2E] px-4 py-2 rounded-lg hover:bg-[#7A3B2E] hover:text-white transition">
            ← Voltar para o Início
          </button>
        </Link>
      </div>

      <div className="text-sm text-gray-500 mb-6 relative z-10">
        INÍCIO » <span className="text-[#7A3B2E] font-semibold">BLOG</span>
      </div>

      <div className="flex flex-col lg:flex-row gap-10 relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 flex-1">
          {filteredPosts.map((post) => (
            // CADA CARD AGORA É UM LINK PARA A PÁGINA DO POST
            <Link href={`/blog/${post.slug}`} key={post.slug} legacyBehavior>
              <a className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition h-full flex flex-col">
                <div className="relative h-56 w-full">
                  <Image
                    src={post.image}
                    alt={post.title}
                    fill
                    // AQUI ESTÁ O AJUSTE: definimos um padrão fixo para a imagem
                    className="object-cover object-center"
                  />
                </div>
                <div className="p-4 flex flex-col flex-grow">
                  <span className="text-xs text-[#7A3B2E] font-semibold mb-2">{post.category}</span>
                  <h2 className="text-lg font-semibold text-[#5A2E1E]">
                    {post.title}
                  </h2>
                </div>
              </a>
            </Link>
          ))}
          {filteredPosts.length === 0 && (
            <p className="text-gray-500 text-sm md:col-span-2 lg:col-span-3">Nenhum post encontrado.</p>
          )}
        </div>

        <aside className="w-full lg:w-[280px] space-y-8">
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <h3 className="text-lg font-semibold text-[#5A2E1E] mb-4">
              CATEGORIAS
            </h3>
            <ul className="space-y-2">
              {categories.map((cat, index) => {
                const count = allPosts.filter((p) =>
                  cat === "Todas" ? true : p.category === cat
                ).length;

                return (
                  <li
                    key={index}
                    className={`flex justify-between text-sm cursor-pointer ${
                      selectedCategory === cat
                        ? "text-[#7A3B2E] font-bold"
                        : "text-gray-700"
                    }`}
                    onClick={() => setSelectedCategory(cat)}
                  >
                    <span>{cat}</span>
                    <span>{count}</span>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="bg-white p-4 rounded-lg shadow-sm">
            <h3 className="text-lg font-semibold text-[#5A2E1E] mb-3">
              Pesquisar no Blog
            </h3>
            <div className="flex items-center">
              <input
                type="text"
                placeholder="Digite sua busca..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="flex-1 border px-3 py-2 rounded-l-lg text-sm focus:outline-none"
              />
              <button
                className="bg-[#7A3B2E] text-white px-4 py-2 rounded-r-lg text-sm"
              >
                🔍
              </button>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default BlogPage;